function removeslide(){
   $('.slide-right-container').removeClass('visible');
   $('.slider-content').each(function() { $(this).hide();		});	
   $('.overlay').hide().closest('.shopify-section').removeClass('z-2');
   $('.popup').removeClass('visible').addClass('slide-init');
   $('body').removeClass('no-scroll popup-open');
     $('.section-columns').removeClass('z-1')
  $('.header-sections').addClass('z-11');
    if($('.form__wrapper').length>0){
    $('.form__wrapper').addClass('is-sticky');
  }

}
function showoverlay(){
  $('.overlay').show().closest('.shopify-section').addClass('z-2');;
  $('body').addClass('no-scroll popup-open');
  $('.header-sections').removeClass('z-11');
  $('.section-columns').addClass('z-1')
  if($('.form__wrapper').length>0 && $('.form__wrapper').hasClass('is-sticky')){
    $('.form__wrapper').removeClass('is-sticky');
  }
}

function showTab(tabIndex) {
  // Hide all tabs
   $(".tab").removeClass("tab-active");
  // Show the selected tab
  $('.tab[tab="'+tabIndex+'"]').addClass("tab-active");
  }

function showClosest(closestname, closestaddress, closestphone, closestemail, stock){
    var availablity;
    if(stock >0){ availablity = 'in stock'}
    else{ availablity = 'in stock within 3 business days'}
    $('#closest .location-card-container').append('<div class="location-card"><div class="title">'+closestname+'</div><div class="availablity"> '+availablity+'</div><div class="discription"> '+closestaddress+'</div><a name="'+closestname+'" address="'+closestaddress+'" phone="'+closestphone+'" email="'+closestemail+'"  class="btn white-btn store-app-btn">Request an appointment</a></div>');
    // $('.store-app-btn[name="Sapphire Dreams Head Office"]').html('Book an appointment').attr("onclick","Calendly.showPopupWidget('https://calendly.com/sapphiredreamsaustralia/showroom-meeting?primary_color=04304b');return false;").removeClass('store-app-btn');      
    $('.store-app-btn[name="Sapphire Dreams Head Office"]').html('Book an appointment').attr("href","/pages/book-an-appointment").removeClass('store-app-btn');     
  }

  //get find closest stores
  function toRad(v){return v * Math.PI / 180;}
  function LatLong(lat, lon) {
    return {Latitude: lat, Longitude: lon}
  }
  function haversine(l1, l2) {

    var R = 6371; // km 
    var x1 = l2[0]-l1[0];
    var dLat = toRad(x1);  
    var x2 = l2[1]-l1[1];
    var dLon = toRad(x2);  
    // console.log('findClosestlatlon_x:'+l2[0]+l2[1]+'custlatlon:'+l1[0]+l1[1]);
    
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) + 
        Math.cos(toRad(l1[0])) * Math.cos(toRad(l2[0])) * 
        Math.sin(dLon/2) * Math.sin(dLon/2);  
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c;


    return d;
  }

  function findClosest(locations, custlatlon) { 
    var distances = [];
    var shortest = 999999;
    var closestname;

    locations.forEach(function(location){
        //  console.log('findClosestlatlon:'+ location.latlon+'custlatlon:'+custlatlon);
      var disBetween = haversine(custlatlon, location.latlon);
      // console.log('disbetween:'+ disBetween);
      if(disBetween < 150){
        distances.push({ location: location, distance: disBetween });
      }
    
        if(disBetween < shortest){
          shortest = disBetween;
          closestname = location.name;
          closestaddress = location.address;
          // closeststockist = location.stockistname;
          closestemail = location.email;    
          closestphone = location.phone;   
          closeststock =  location.stock; 
        }
    
    
        
    });
    
    distances.sort(function(a, b) {
        return a.distance - b.distance;
    });
    
    console.log('distances'+distances);
    $('#closest .location-card-container').html('');
    if(distances.length == 0){
      $('#closest h3').text('No store in your area. We found you the closest store:');
      showClosest(closestname, closestaddress, closestphone, closestemail, closeststock);
      
    }
    else{
      if(distances.length>3){dislength = 3}
      else{dislength = distances.length}
      $('#closest h3').text(dislength+' stores in your area.');
      for (let index = 0; index < 3; index++) {
        showClosest(distances[index].location.name, distances[index].location.address, distances[index].location.phone, distances[index].location.email, distances[index].location.stock);

      }
    }
      
    // $('#closest').text("Closest location is "+distances[0].location.name+" at a distance of "+distances[0].distance+" km");
    
    }    

function initializeStoneShapeIcons() {
  if ($('.filter-group').length > 0) {
    $('input[name="filter.p.m.custom.stone_shape"]').each(function () {
      var shape = $(this).attr('value').replace(/\s+/g, '-').toLowerCase();
      if (!$(this).parent().find('i.fa-kit').length) { // Prevent duplicate icons
        $(this).parent().find('label').prepend('<i class="fa-kit fa-' + shape + '-diamond"></i>');
      }
    });
  }
}

function initializeCollectionPage() {
  initializeStoneShapeIcons();

  // Event delegation for dynamically loaded elements
  $(document).on('click', '.filter-group__heading', function () {
    initializeStoneShapeIcons();
  });

  // ...existing code for other collection page-specific logic...
}

jQuery(document).ready(function ($) {
  initializeCollectionPage();

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.filter-group')) {
      initializeStoneShapeIcons();
    }
  });

  $('.header-sections').addClass('z-11');
  // button clicks
    $('body').on('click', '.overlay', function(){removeslide()});
    $('body').on('click', '.cancel-btn', function(){removeslide()});

    $('.options-container label').click(function(){removeslide(); $('.raido-btn-container .error-msg').hide(); $('.ring-size-btn').removeClass('red-border');});

// popup

// $('.popup').addClass('slide-init');
  
  	$('.slide-btn').click(function(){
	  $('.'+ $(this).attr('slide')).addClass('visible');
      showoverlay();
	});
  $('.spec-btn').click(function(){
    $('.slider-content').each(function() { $(this).hide();		});	
	  $('.'+ $(this).attr('slide')).show();
	  $('.slide-right-400').addClass('visible');
	  showoverlay();
	});
  
    $('.ring-size input[type="radio"]').click(function(){
            $('.ring-size-btn .btn-right').text($(this).attr('value'));
            $('.select-finger-size').addClass('btn-left').text('Size:'); 
            
    });



  	$('.popup-btn').click(function(){
        popname = $(this).attr('popup');

		// $('.popup').removeClass('slide-init').addClass('visible');
        $('.popup').each(function(){      
          if($(this).attr('popname') == popname){$(this).removeClass('slide-init').addClass('visible');}
          else{$(this).removeClass('visible').addClass('slide-init');}
        });
	  showoverlay();
	});  

  //add to cart form validation
    
  $('.product__submit button[type="submit"]').click(function() {
  // console.log('submit');
  if($('.ring-size-btn').length > 0 ){
    if($('.ring-size-btn .btn-right').text()==""){ 
      $('.raido-btn-container .error-msg').css('display', 'inline-block');

      $('.ring-size-btn').addClass('shake');
      $('.ring-size-btn').addClass('red-border');
      return false;
    }
    else{   
      $('.raido-btn-container .error-msg').hide();   
      $('.ring-size-btn').removeClass('red-border');

      return true;
    }
  }

  });

//hide collection-content text

$(".collection-content").each(function() {
  var content = $(this).text(); // Get the full content
  var contenthtml= $(this).html();
  var maxLength = 70; // Define the maximum length of visible characters

  // If the content is longer than the maxLength
  if (content.length > maxLength) {
      // Find the last space within the maxLength
      var visibleText = content.substr(0, maxLength);
      var lastSpaceIndex = visibleText.lastIndexOf(' ');

      // If there's a space within the maxLength, truncate at the last space
      if (lastSpaceIndex > -1) {
          visibleText = content.substr(0, lastSpaceIndex);
      }

      var hiddenText = content.substr(visibleText.length); // Get the rest of the content

      // Set up the HTML structure for truncating and showing/hiding the text
      $(this).html('<span class="shorttxt show-mb">'+visibleText + '</span><span class="more-text hide-mb" >' + contenthtml + '</span>' +
          ' <a href="#" class="read-more show-mb">read more...</a>');
  }
});

    // Toggle the "read more/less" functionality
    $(".collection-content").on("click", ".read-more", function(e) {
      e.preventDefault();

      if($(this).text() == "read more..."){
        $(this).prev(".more-text").removeClass('hide-mb');
        $('.shorttxt').removeClass('show-mb').hide();
        $(this).text("read less...");
      }
      else{
        $(this).prev(".more-text").addClass('hide-mb');
        $('.shorttxt').addClass('show-mb').show();
        $(this).text("read more...");
      }

  });

  var sdSpinSrc = '';
  var sdSpinOptions = 'fullscreen:false; zoom:0; hint:false';
  var sdSpinClick = { active: false, moved: false, x: 0, y: 0, t: 0 };

  function hideSirvSpinChrome() {
    document.querySelectorAll(
      '.spin-slide .sirv-spin-button, .spin-slide .sirv-spin-hint, .spin-slide .sirv-controls, .spin-slide .magnifier, .spin-slide .ihint, .sd-spin-fs-overlay .sirv-spin-button, .sd-spin-fs-overlay .sirv-spin-hint, .sd-spin-fs-overlay .sirv-controls, .sd-spin-fs-overlay .magnifier'
    ).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function watchSirvSpinChrome() {
    var slide = document.querySelector('.spin-slide');
    if (!slide || slide._sdSpinUiWatch) {
      return;
    }
    slide._sdSpinUiWatch = true;
    hideSirvSpinChrome();
    new MutationObserver(hideSirvSpinChrome).observe(slide, { childList: true, subtree: true });
  }

  function closeSpinFullscreen() {
    var overlay = document.getElementById('sd-spin-fs-overlay');
    if (overlay) {
      overlay.classList.remove('is-open');
    }
    document.body.classList.remove('sd-spin-fs-open');
  }

  function openSpinFullscreen() {
    var src = sdSpinSrc;
    if (!src) {
      var spinEl = document.getElementById('sirv-spin');
      if (spinEl) {
        src = spinEl.getAttribute('data-src') || spinEl.dataset.src;
      }
    }
    if (!src) {
      return;
    }

    var overlay = document.getElementById('sd-spin-fs-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'sd-spin-fs-overlay';
      overlay.className = 'sd-spin-fs-overlay';
      overlay.innerHTML =
        '<div class="sd-spin-fs-panel">' +
        '<div class="Sirv sd-spin-fs-sirv" id="sirv-spin-fullscreen"></div>' +
        '</div>';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closeSpinFullscreen();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeSpinFullscreen();
        }
      });
    }

    overlay.querySelector('.sd-spin-fs-sirv').setAttribute('data-src', src);
    overlay.querySelector('.sd-spin-fs-sirv').setAttribute('data-options', sdSpinOptions);
    overlay.classList.add('is-open');
    document.body.classList.add('sd-spin-fs-open');

    if (window.Sirv && typeof window.Sirv.start === 'function') {
      window.Sirv.start();
    }
    setTimeout(hideSirvSpinChrome, 100);
    setTimeout(hideSirvSpinChrome, 600);
  }

  function isSpinSlideVisible($slide) {
    var el = $slide[0];
    if (!el) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 20 && rect.height > 20 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function showSpinGallery() {
    $('.product__images').addClass('spin-gallery-active');
    $('.product__slide.media--active').removeClass('media--active').addClass('media--hidden');
    $('.spin-slide').removeClass('media--hidden').addClass('media--active');
    setTimeout(function () {
      if (window.Sirv && typeof window.Sirv.start === 'function') {
        window.Sirv.start();
      }
      hideSirvSpinChrome();
    }, 400);
  }

  function hideSpinGallery() {
    $('.product__images').removeClass('spin-gallery-active');
    $('.spin-slide').removeClass('media--active').addClass('media--hidden');
    closeSpinFullscreen();
  }

  // product page
    if($('body[type="product"]').length  >0 ){
        var sku = $('.product__sku').attr('sku');

        if($('#select-ring-size').length > 0){
          $('#select-ring-size').insertBefore($('.product__submit__item button[type="submit"]'));
        }

        // show spin image  
        var spinsrc = "https://samsgroup.sirv.com/SD-Product/Sapphire%20Dreams%20Products/" + sku + "/" + sku + ".spin?fullscreen=false&zoom=0&hint=false"
        $.ajax( spinsrc, {
          statusCode: {
            404: function() {
  
              },
            200: function() {

            // $('<div class="product__slide media--hidden spin-slide"><div class="Sirv" id="sirv-spin" data-src="'+spinsrc+'"></div></div>').insertBefore($('.product__slide').eq(-1));
            $('<div class="product__slide media--hidden spin-slide"><div class="Sirv" id="sirv-spin" data-src="'+spinsrc+'" data-options="'+sdSpinOptions+'"></div></div>').appendTo($('.product__slides'));
            $('<div class="product__thumb" data-thumb-item=""><a class="product__thumb__link spin-thumb"><figure class="image-wrapper" style="--aspect-ratio: 1;"><img src="//cdn.shopify.com/s/files/1/0592/1996/8207/files/360.jpg" alt="360 spin"></figure></a></div>').insertBefore($('.product__thumb').eq(-1));

            sdSpinSrc = spinsrc;
            watchSirvSpinChrome();
            if (window.Sirv && typeof window.Sirv.start === 'function') {
              window.Sirv.start();
            }
            setTimeout(hideSirvSpinChrome, 500);
            }
          }
        });

        var inventoryxml = "https://samsgroup.sirv.com/SD_inventory/SD_inventory.xml";
        var storexml = "https://samsgroup.sirv.com/SD_inventory/SD_stores.xml";
        var australian_postcodes = "https://samsgroup.sirv.com/SD_inventory/australian_postcodes.xml"
        var productsku = $('#pr_sku_ppr').text();
        var appointmentemail = "contact@sapphiredreams.com.au";
        var appointmentphone;
        var appointmentstore;
        var appointmentaddress;
  
  
        // var appointmentemail = "treble_l@hotmail.com";
        const availablestore = [];
        const availablelocation = [];
  
        $.ajax({
          type: "GET",
          url: storexml,
          dataType: "xml",
          success: function(store) {
              $(store).find('Store').each(function() {
                  storename = $(this).find('Name').text();
                  // stockistname = $(this).find('OwnerFirst').text()+' '+$(this).find('OwnerSurname').text();
                  storeaddress = $(this).find('Address').text();
                  storeemail = $(this).find('Email').text();
                  storephone = $(this).find('Phone').text();
                  storelatlon = $(this).find('Latlon').text();
                  var stock = 0;
                  var latlonArr = storelatlon.split(',');
                  var lat = parseFloat(latlonArr[0]);
                  var lon = parseFloat(latlonArr[1]);
                  availablelocation.push({name: storename, address: storeaddress, email: storeemail, phone: storephone, stock: stock, latlon: [lat, lon]});
              });
          }
      });
      
      
      
        $.ajax({
          type: "GET" ,
          url: inventoryxml ,
          dataType: "xml" ,
          success: function(data) {
            var xml = jQuery( data );
  
            jQuery(xml).find('product').each(function() {
        
                if( productsku == jQuery(this).find('SKU').text()){
                  $(this).find('*').each(function(){
                    //  console.log('name:'+jQuery(this).prop("tagName"));
                    if(($(this).text() != '0') && (jQuery(this).prop("tagName").indexOf('Store-')>-1)){ 
                      availablestore.push([jQuery(this).prop("tagName").slice(6).split("_").join(" "), $(this).text()]); 
                    }
                    // console.log(jQuery(this).prop("tagName") + 'inv:'+$(this).text());
                         
                  });
                } 
              });
          }
        
        });
  
        $("#stockist-app").click(function(){
  
  
          var yourlatlon;
          var yourpostcode;
          var postcodeexist = false;
  
          $('#closest').show();
          $('.pro-info').slideUp();
          // Get the value of the input element
          yourpostcode =  $('#youraddress').val().toString();
  
          $.ajax({
            type: "GET" ,
            url: australian_postcodes ,
            dataType: "xml" ,
            success: function(data) {
              var xml = jQuery( data );
    
              jQuery(xml).find('item').each(function() {
          
                var lat = jQuery(this).find('lat').text();
                var lon = jQuery(this).find('long').text();
     
              
                if (yourpostcode == jQuery(this).find('postcode').text()) {
                  yourlatlon = [parseFloat(lat), parseFloat(lon)];
                  console.log('yourlatlon'+yourlatlon+', yourpostcode'+yourpostcode);
                  findClosest(availablelocation, yourlatlon);
                  postcodeexist = true;
                  return false; // Exit the loop if a match is found
                }
                if(postcodeexist == false){  }
                });
            }
          
          });  
            
            availablelocation.forEach(function(location){
              availablestore.forEach(function(store){
               
               if(store[0] == location.name){location.available = true; location.stock = store[1];}
               else{location.available = false;}
  
             });
           });
  
      });
      $('#youraddress').keypress(function(event) {
        // Check if the pressed key is Enter (key code 13)
        if (event.which === 13) {
          // Prevent the default form submission behavior
          event.preventDefault();
          // Trigger the click event on the 'show locations' button
          $('#stockist-app').click();
        }
      });        
      
    }

    $(document).on('mousedown touchstart', '.spin-slide', function (e) {
      if (!isSpinSlideVisible($(this))) {
        return;
      }
      var pt = e.type === 'touchstart' ? e.originalEvent.touches[0] : e;
      sdSpinClick.active = true;
      sdSpinClick.moved = false;
      sdSpinClick.x = pt.clientX;
      sdSpinClick.y = pt.clientY;
      sdSpinClick.t = Date.now();
    });

    $(document).on('mousemove touchmove', function (e) {
      if (!sdSpinClick.active) {
        return;
      }
      var pt = e.type === 'touchmove' ? e.originalEvent.touches[0] : e;
      if (!pt) {
        return;
      }
      if (Math.abs(pt.clientX - sdSpinClick.x) > 30 || Math.abs(pt.clientY - sdSpinClick.y) > 30) {
        sdSpinClick.moved = true;
      }
    });

    $(document).on('mouseup touchend', '.spin-slide', function (e) {
      if (!sdSpinClick.active || !isSpinSlideVisible($(this))) {
        sdSpinClick.active = false;
        return;
      }
      var elapsed = Date.now() - sdSpinClick.t;
      var wasDrag = sdSpinClick.moved;
      sdSpinClick.active = false;
      if (wasDrag || elapsed > 400) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      openSpinFullscreen();
    });

    $(document).on('click', '.spin-thumb', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $thumb = $(this).closest('.product__thumb');
      $('.product__thumb').removeClass('is-active');
      $thumb.addClass('is-active');
      showSpinGallery();
    });

    $(document).on('click', '.product__thumb', function () {
      if ($(this).find('.spin-thumb').length) {
        return;
      }
      $('.product__thumb').each(function(){ $(this).removeClass('is-active');});
      $(this).addClass('is-active');
      hideSpinGallery();
    });

$('.slide-container').slick();

    //tabs
    $('.tab-btn').click(function(){
      $('.tab-btn').each(function(){
        $(this).removeClass('active');
      });
      $(this).addClass('active');
      var tabnum=$(this).attr('totab');
      showTab(tabnum);
    });
    $('.tab-prev').click(function(){ 
      var tabnum = $(this).closest('.tab').attr('tab')-1;
      showTab(tabnum)
    });
    $('.tab-next').click(function(){ 
      var tabnum = $(this).closest('.tab').attr('tab')+1;
      showTab(tabnum)
    });

    //get store email



  $(document).on('click', '.store-app-btn', function() {
    showTab(2);
    appointmentstore = $(this).attr('name');
    appointmentaddress = $(this).attr('address');
    appointmentphone = $(this).attr('phone');
    appointmentemail = $(this).attr('email');
    // stockistname = $(this).attr('stockistname');
    
    $('.storeinfo .name .content').text(appointmentstore);
    $('.storeinfo .phone .content').text(appointmentphone);
    $('.storeinfo .phone .content').attr('href', 'tel:'+appointmentphone);
    $('.storeinfo .email .content').text(appointmentemail)
    $('.storeinfo .email .content').attr('href', 'mailto:'+appointmentemail);
    $('.storeinfo .address .content').text(appointmentaddress);

  });

// appointment form
$('#storeapp').submit(function(event) {
  event.preventDefault();

  // Get form data
  var name = $('#storeapp #Name').val();
  var email = $('#storeapp #Email').val();
  var phone = $('#storeapp #Phone').val();
  var message = $('#storeapp #Message').val();
  var appointmentdate = $('#storeapp #Date').val();
  var appointmenttime = $('#storeapp #Time').val();

  // Send form data to URL
  var url = 'https://samsgroup.info/wp-content/sdforms/storeapp.php?sendto='+appointmentemail+'&appointmentaddress='+appointmentaddress+'&appointmentstore='+appointmentstore+'&appointmentdate='+appointmentdate+'&appointmenttime='+appointmenttime+'&appointmentphone='+appointmentphone+'&product='+productsku+'&name='+name+'&message='+message+'&phone='+phone+'&email='+email;
  
  window.open(url, '_blank');
  

  $('.appointmentinfo .name .content').text(appointmentstore);
  $('.appointmentinfo .phone .content').text(appointmentphone);
  $('.appointmentinfo .address .content').text(appointmentaddress);
  $('.appointmentinfo .date .content').text(appointmentdate);
  $('.appointmentinfo .time .content').text(appointmenttime);

  showTab(3);
});
  
  
});
